import React from 'react'
import Contact from '../../components/Contact/Contact'
import Nav from '../../components/NavBar/Nav'
import Footer from '../../components/Footer/Footer'

const index = () => {
  return (
    <div>
        <Nav/>
        <Contact/>
        <Footer/>
    </div>
  )
}

export default index